/** Supported report download/export formats used across frontend and backend reporting flows. */
export enum ReportExportFormat {
  PDF = "PDF",
  XLSX = "XLSX",
  XML = "XML",
}
